module.exports = __webpack_public_path__ + "img/bmwcharging-ic.67b5a26c.svg";